import DataTable from '@medeloop/medeloop-components-library/dist/components/DataTable';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { StudyParticipant } from 'src/types/studies';

interface StudyParticipantsTableProps {
  participants: StudyParticipant[];
}

export function StudyParticipantsTable({ participants }: StudyParticipantsTableProps) {
  const { t } = useTranslation();

  return (
    <DataTable className="px-6 py-4">
      <DataTable.Header>
        <DataTable.HeaderCell>{t('first_name_header')}</DataTable.HeaderCell>
        <DataTable.HeaderCell>{t('last_name_header')}</DataTable.HeaderCell>
        <DataTable.HeaderCell>{t('joined_header')}</DataTable.HeaderCell>
      </DataTable.Header>
      <DataTable.Body className="h-96 overflow-auto">
        {participants.length > 0 ? (
          participants.map((participant) => (
            <DataTable.Row key={participant.participantId}>
              <DataTable.RowCell>{participant.givenName}</DataTable.RowCell>
              <DataTable.RowCell>{participant.familyName}</DataTable.RowCell>
              <DataTable.RowCell>
                {dayjs(participant.createdAt).format('YYYY-MM-DD')}
              </DataTable.RowCell>
            </DataTable.Row>
          ))
        ) : (
          <div className="flex flex-grow items-center justify-center p-4">
            <p>{t('no_participants_in_study')}</p>
          </div>
        )}
      </DataTable.Body>
    </DataTable>
  );
}
